import reducer from "./reducer";
export { default as AdvancesSettings } from "./components/index";
export { default as advancesSettingsReducerName } from "./constants";
export default reducer;
